Ext.define('SA.BarChartSvgResult', {
    constructor({el, barWidth, yAxisHeight}) {
        var {width, height} = el.getBBox();

        this.el = el;
        this.size = {width, height, barWidth, yAxisHeight};
    },

    getEl() {
        return this.el;
    },

    getSize() {
        return this.size;
    }
});